import { EncounterRegionNoteModel } from '../api/proxy/practice/models/encounter-region-note-model';
import { NotesModel } from '../api/proxy/practice/models/notes-model';
import { TreatmentQueueStatusType } from '../api/proxy/practice/models/treatment-queue-status-type';
import { PatientTreatmentQueueModel } from '../api/proxy/practice/models/patient-treatment-queue-model';
import { cloneSoapNotesForDuplicate } from '../services/treatment-service/pending-soap.util';
import {
  cloneQueuedRegionNotes,
  playlistToQueueParts,
  playlistToQueuedTreatmentNotes,
} from './queue-draft.mapper';
import { ITreatmentPlayListItem } from '../pages/treatment/treatment.page';

/** POST body for creating or upserting a patient treatment queue. */
export function buildPatientTreatmentQueuePostBody(args: {
  isCreateMode: boolean;
  queueId: string | null;
  clinicGroupId: string;
  patientId: string;
  loadedEncounterId: string | null | undefined;
  loadedStatus: TreatmentQueueStatusType | undefined;
  loadedRecurring?: boolean;
  loadedScheduleDate?: string | null;
  playlist: ITreatmentPlayListItem[];
  notes?: NotesModel | null;
  regionNotes?: EncounterRegionNoteModel[] | null;
  /** When set, only those leftover untreated levels are written to queue treatment notes. */
  treatmentNoteKeys?: Iterable<string> | null;
  /** @deprecated Use treatmentNoteKeys. */
  findingKeys?: Iterable<string> | null;
  statusOverride?: TreatmentQueueStatusType;
  recurring?: boolean;
  scheduleDate?: string | null;
}): PatientTreatmentQueueModel {
  const onlyPartKeys = args.treatmentNoteKeys ?? args.findingKeys ?? null;

  return {
    id: args.isCreateMode ? null : args.queueId,
    clinicGroupId: args.clinicGroupId,
    patientId: args.patientId,
    encounterId: args.loadedEncounterId ?? null,
    status: args.statusOverride
      ?? (args.isCreateMode
        ? TreatmentQueueStatusType.Queued
        : args.loadedStatus ?? TreatmentQueueStatusType.Queued),
    recurring: args.recurring ?? args.loadedRecurring ?? false,
    scheduleDate: args.scheduleDate ?? args.loadedScheduleDate ?? null,
    parts: playlistToQueueParts(args.playlist),
    treatmentNotes: playlistToQueuedTreatmentNotes(args.playlist, { onlyPartKeys }),
    regionNotes: cloneQueuedRegionNotes(args.regionNotes),
    notes: cloneSoapNotesForDuplicate(args.notes),
  };
}
